/**
 * Generate a cryptographically secure random hex string.
 * @param byteCount - Number of random bytes to generate (each byte produces 2 hex characters)
 * @returns A hex string of length byteCount * 2
 */
export function generateSecureRandomHex(byteCount: number): string {
  const arr = new Uint8Array(byteCount);
  globalThis.crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}
